import { Col, Row } from "react-bootstrap";
import SvgMobileMenuArrow from "./SvgMobileMenuArrow";
interface Props {
  title: {
    Svg?: any;
    url?: string;
    text?: string;
    other?: any;
  };
  rotate?: boolean;
  dropdown?: boolean;
  isFooter?: boolean;
  textDecoration?: boolean;
}
const MobileMenuItemTitle: React.FC<Props> = ({
  title,
  rotate = false,
  dropdown = false,
  isFooter,
  textDecoration,
}) => {
  const { Svg, url, text, other } = title ?? {};
  return (
    <Row
      style={{ paddingInlineEnd: 8 }}
      className="m-0 d-flex align-items-center"
    >
      <Col className="p-0 d-flex align-items-center col-auto">
        {Svg && <div style={{ marginInlineEnd: 8 }}>{Svg}</div>}
        {url && (
          <div style={{ marginInlineStart: -16, marginInlineEnd: 12 }}>
            {/* eslint-disable-next-line  @next/next/no-img-element*/}
            <img alt="url" src={url} width={24} height={24} />
          </div>
        )}
        <div
          className={isFooter ? "footer-menu-nav-link " : ""}
          style={{
            textDecorationLine:
              !isFooter && textDecoration ? "underline" : "initial",
          }}
        >
          {text}
        </div>
      </Col>
      {other && <Col className="p-0 d-flex justify-content-end">{other}</Col>}
      {dropdown && (
        <Col
          className={`p-0 d-flex ${!isFooter ? "justify-content-end" : ""}`}
          style={{ gap: 5 }}
        >
          <SvgMobileMenuArrow rotate={rotate} />
        </Col>
      )}
    </Row>
  );
};

export default MobileMenuItemTitle;
